
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class Auth extends Vue {
  loading: boolean = true;
  error: boolean = false;


  async mounted() {
    if(await this.$auth.isLoginRedirect()) {
      this.handleCallback()
    } else {
      this.handleAuthentication()
    }
  }

  async handleCallback() {
    try {
      await this.$auth.storeTokensFromRedirect();
      await this.handleAuthentication();
    } catch (err) {
      console.log(err)
    }
  }

  async handleAuthentication() {
    try {
      const isAuthenticated = await this.$auth.isAuthenticated();
      const isLoggedIn      = await (this.$root as any).isLoggedIn();

      if (isAuthenticated) {
        if (isLoggedIn && (this.$root as any).tokenIsExpired(this.$store.state.token)) {
          await this.redirectToHome();
        } else {
          await this.authenticateInBackend();
        }
      } else {
        this.$router.push("/login");
      }
    } catch (e) {
      console.log(e);
    }
  }

  async redirectToHome() {
    const role = this.$store.state.user.type;

    if (role === 1 || role === 2 || role === 4) {
      this.$router.push("/admin/dashboard");
    } else {
      const dashboard = await this.dashboardRoute();
      return this.$router.push(dashboard);
    }
  }

  async authenticateInBackend() {
    try {
      let response: any = await (this.$root as any)._post("auth");

      this.$store.commit("setToken", response.token);

      let role = response.user.role;

      if (role === 1 || role === 2) {
        await this.getAdminData(response.user.id, role);
      } else {
        await this.getClientData(response.user.id, role);
      }
    } catch (e) {
      console.log(e);
      this.loading = false
      this.error = true
    }
  }

  async getAdminData(id, role) {
    let adminResponse = await (this.$root as any)._get(`admins/one/${id}`);

    if (adminResponse.data[0].companies)
      adminResponse.data[0].companies = adminResponse.data[0].companies.map(
        c => c.id
      );

    this.$store.commit("setUser", adminResponse.data[0]);
    this.$router.push("/admin/dashboard");
  }

  async selectRoute () {
    const business: any = await (this.$root as any)._get(`businesses/one/${this.$store.state.user.businessId}`);
    switch (business.data.type_id) {
      case 2:
          return "/facility/select";
      case 1:
      default:
          return "/seleccionar-empresa";
    }
  }

  async dashboardRoute () {
    const business: any = await (this.$root as any)._get(`businesses/one/${this.$store.state.user.businessId}`);
    switch (business.data.type_id) {
      case 2:
        return this.$router.push("/facility/dashboard");
      case 1:
      default:
        return this.$router.push("/dashboard");
    }
  }

  async getClientData(id, role) {
    let response = await (this.$root as any)._post(`subscriptors/one/${id}`, {
      models: "companies"
    });

    response.data[0].role = role;

    this.$store.commit("setUser", response.data[0]);

    if (response.data[0].companies.length > 1) {
        const route = await this.selectRoute();
        return this.$router.push(route);
    } else {
      this.$store.commit("setCompanyId", response.data[0].companies[0].id);
      this.$router.push("/dashboard");
    }
  }

  async logout() {
    await (this.$root as any).logout();
  }
}
